/**
 * File: FooterNavigation.js
 * Origin: isotect
 * Description: [TODO: Description]
 *
 * Version: v2.0.1
 * Created: 2025-07-30
 * Last Updated: 2026-04-10
 *
 * Used By: isotect
 * Maintainer: Zachary Dicks
 *
 * Notes:
 * - Changes in this file may affect all consuming frontend modules.
 * - See Git repository 'isotect' for full change history.
 */

// Third-party packages
import { Link } from "react-router-dom";

/**
 * [TODO: Component description here]
 *
 * @returns {JSX.Element} [TODO: Rendered output]
 */
function FooterNavigation({ props }) {
    return (
        <>
            <nav className="footer-navigation">
                {Object.entries(props).map(([category, list]) => (
                    <div className="footer-navigation__list" key={category}>
                        {list.map((item, index) => (
                            <Link
                                key={item.label}
                                to={item.link}
                                className={
                                    index === 0
                                        ? "footer-navigation__header"
                                        : ""
                                }
                            >
                                {item.label}
                            </Link>
                        ))}
                    </div>
                ))}
            </nav>
        </>
    );
}

export default FooterNavigation;
